
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/flutter",
      function () {
        return require("private-next-pages/docs/link/flutter/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/flutter"])
      });
    }
  